<template>
  <div class
         ="light-order-list table-responsive">
    <return-list-filter/>
    <table>
      <thead>
      <tr>
        <th>Код заказа</th>
        <th>Дата</th>
        <th>Товары в заказе</th>
        <th>Действие</th>
      </tr>
      </thead>
      <tbody>

      <tr v-for="order of orders">
        <td>
          <div>
            <div>
              <strong>
                {{order.ID}}
              </strong>
            </div>

          </div>
        </td>
        <td>
          {{order.DATE_INSERT}}
        </td>
        <td>
          <div v-for="item of order.items">
            {{item.NAME | truncate(50)}}
          </div>
          <br>
        </td>
        <td>
          <div v-for="item of order.items">
            <div v-if="isProductStatusActive(item, order)">
              {{getProductStatusActive(item, order)}}
            </div>
            <a v-else-if="item.IS_SHOW_WARRANTY" class="link--success" href="#" @click="request(item, $event)">Обратиться
              по гарантии</a>
            <div v-else>
              Срок обращения истёк
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ReturnRequest from './ReturnRequest'
  import ReturnListFilter from './ReturnListFilter'
  import _ from 'lodash'

  export default {
    name: 'return-list',
    components: {ReturnRequest, ReturnListFilter},
    created () {
      if (this.orders.length <= 0) {
        this.$store.dispatch('return/fetchOrders')
      }
    },
    computed: {
      ...mapGetters('return', [
        'orders',
        'currentItem',
        'error',
        'currentTab',
        'history'
      ])
    },
    methods: {
      request (item, $event) {
        $event.preventDefault()
        this.$store.commit('return/setCurrentItem', {item})
      },
      isProductStatusActive (item, order) {
        return _.findIndex(this.history, h => h.orderNumber === order.ID && h.status.length > 0 && item.NAME === h.name) > -1
      },
      getProductStatusActive (item, order) {
        let status = _.find(this.history, h => h.orderNumber === order.ID && h.status.length > 0 && item.NAME === h.name).status[0]
        return status
      }
    },
    mounted () {
      console.log('mounted')
      window.onscroll = () => {
        if (this.currentTab === 'return') {
          let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >
            document.documentElement.offsetHeight - 500

          if (bottomOfWindow) {
            this.$store.dispatch('return/fetchOrders')
          }
        }
      }
    },
    beforeDestroy () {
      window.onscroll = null
      console.log('beforeDestroy')
    }
  }
</script>

<style scoped>
  .light-order-list {
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/Return/ReturnList.vue